document.addEventListener("DOMContentLoaded", () => {
  const lightbox = document.getElementById("lightbox");
  if (!lightbox) return;

  const images = Array.from(document.querySelectorAll(".boxes-images img"));
  const lightboxImage = document.getElementById("lightbox-image");

  let currentIndex = 0;

  function showImage() {
    lightboxImage.classList.add("p-opacity-0");
    lightboxImage.src = images[currentIndex].src;

    const show = () => {
      lightbox.classList.remove("p-hidden");

      requestAnimationFrame(() => {
        lightbox.classList.remove(
          "p-opacity-0",
          "p-scale-95",
          "p-pointer-events-none"
        );
        lightboxImage.classList.remove("p-opacity-0");
      });
    };

    if (lightboxImage.complete) {
      show();
    } else {
      lightboxImage.onload = show;
    }
  }

  function closeLightbox() {
    lightbox.classList.add(
      "p-opacity-0",
      "p-scale-95",
      "p-pointer-events-none"
    );
    lightboxImage.classList.add("p-opacity-0");

    setTimeout(() => {
      lightbox.classList.add("p-hidden");
    }, 400);
  }

  function nextImage() {
    currentIndex = (currentIndex + 1) % images.length;
    showImage();
  }

  function prevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    showImage();
  }

  images.forEach((img, index) => {
    img.addEventListener("click", () => {
      currentIndex = index;
      showImage();
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeLightbox();
    if (e.key === "ArrowRight") nextImage();
    if (e.key === "ArrowLeft") prevImage();
  });

  const btnClose = document.querySelector("[data-lightbox-close]");
  const btnPrev = document.querySelector("[data-lightbox-prev]");
  const btnNext = document.querySelector("[data-lightbox-next]");

  if (btnClose) btnClose.addEventListener("click", closeLightbox);
  if (btnPrev) btnPrev.addEventListener("click", prevImage);
  if (btnNext) btnNext.addEventListener("click", nextImage);

  lightbox.addEventListener("click", (e) => {
    const clicked = e.target;

    if (clicked === lightbox || clicked.closest("[data-lightbox-close]")) {
      closeLightbox();
    }
  });
});
